import PropTypes from 'prop-types';

const RouteItem = PropTypes.shape({
  id: PropTypes.number,
  substance: PropTypes.any,
  step: PropTypes.string,
  leafNode: PropTypes.bool,
  parentId: PropTypes.number,
});

export default RouteItem;
